import { useState } from 'react';
import './ServiceList.scss';
import Button from './Button';

export type Cta = {
    label: string;
    url: string;
}

export type ServiceItem = {
    title: string;
    description: string;
    imageURL?: string;
    cta?: Cta;
}

const ServiceList = ({
    serviceItems
} : {
    serviceItems: ServiceItem[]
}) => {

    const [isOpen, setIsOpen] = useState<string>('');

    return (
        <section className='services'>
            <ul className='services-list container'>
                {serviceItems.map((item) => 
                <li 
                    className={`service-item ${isOpen === item.title ? 'selected' : ''}`}
                    aria-label={`${item?.title}`}
                    onClick={() => {
                        if (isOpen === item.title) {
                            setIsOpen('');
                        } else {
                            setIsOpen(item.title);
                        }
                    }}
                >
                    <h2 className='service-title'>
                        <span>{item.title}</span>
                        <span>{isOpen === item.title ? '-' : '+'}</span>
                    </h2>
                    <p 
                        className={`service-description`}
                    >
                        {item.description}
                    </p>
                    {item.cta && <Button label={item.cta?.label} goTo={item.cta?.url}/>}
                </li>)}
            </ul>
        </section>
    )
}

export default ServiceList;